import type { Template } from "@/types";

export const LA_06_H0_V6: Template[] = [
    {
        id: "la-06-h0v6-01",
        name: "LA 01 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 48, width: 262, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 403, y: 48, width: 140, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 403, y: 245, width: 140, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 48, width: 261, height: 386, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 48, width: 140, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 245, width: 140, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-02",
        name: "LA 02 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 133, y: 48, width: 143, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 245, width: 143, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 284, y: 48, width: 259, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 48, width: 261, height: 386, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 48, width: 140, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 245, width: 140, height: 189, rotation: 0, imageRotation: 0 }         
        ],
    },

    {
        id: "la-06-h0v6-03",
        name: "LA 03 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 107, y: 78, width: 227, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 78, width: 226, height: 327, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 48, width: 261, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 48, width: 101, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1090, y: 180, width: 101, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1090, y: 311, width: 101, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-04",
        name: "LA 04 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 104, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 104, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 104, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 104, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 919, y: 104, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 104, width: 191, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-05",
        name: "LA 05 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 80, width: 219, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 80, width: 219, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 80, width: 219, height: 324, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 80, width: 219, height: 324, rotation: 0, imageRotation: 0 },
            { id: "5", x: 908, y: 80, width: 218, height: 324, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1134, y: 80, width: 218, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-06",
        name: "LA 06 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 169, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 169, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 169, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 169, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 918, y: 169, width: 191, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1117, y: 169, width: 191, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-07",
        name: "LA 07 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 338, height: 483, rotation: 0, imageRotation: 0 },   
            { id: "2", x: 533, y: 37, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 533, y: 246, width: 140, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 37, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 246, width: 139, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1014, y: 0, width: 338, height: 483, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-06-h0v6-08",
        name: "LA 08 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 338, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 437, y: 37, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 437, y: 245, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 776, y: 37, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 776, y: 245, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1014, y: 0, width: 338, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-09",
        name: "LA 09 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 69, y: 71, width: 124, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 246, width: 124, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 200, y: 71, width: 279, height: 342, rotation: 0, imageRotation: 0 },
            { id: "4", x: 486, y: 71, width: 121, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 486, y: 246, width: 121, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 0, width: 376, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-10",
        name: "LA 10 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-06-h0_v6_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 376, height: 483, rotation: 0, imageRotation: 0 },
            { id: "2", x: 745, y: 71, width: 279, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 71, width: 121, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1031, y: 246, width: 121, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1160, y: 71, width: 124, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1160, y: 246, width: 124, height: 167, rotation: 0, imageRotation: 0 }
        ],
    }
];